<template>
  <!-- modal: type-xlarge -->
  <AbstractPop :type-mo-full="true">
    <template v-slot>
      <div id="CYB_PC_TO_02_01" class="modal type-mo-full" data-popup>
        <div class="dialog type-large">
          <header class="dialog-header">
            <h2 class="dialog-title only-pc">업데이트 상세내용</h2>
            <button
              type="button"
              class="dialog-close"
              data-popup-close
              @click="() => emits('close')"
            >
              <span class="c-icon icon-large-x"></span>
              <span class="sr-only">팝업 닫기</span>
            </button>
          </header>

          <div class="dialog-content">
            <div class="dialog-content-inner">
              <!-- D: MO에서만 존재 -->
              <h3 class="c-title-level3 only-mo">업데이트 상세내용</h3>
              <!-- // D: MO에서만 존재 -->
              <div class="update-detail-wrap">
                <div class="head">
                  <span class="date">{{ props.data.mdfcnDt }} </span>
                  <p class="title">
                    {{ props.data.prdctSeNm }} - {{ props.data.cmmPntSeNm }}
                  </p>
                  <div class="file-down-guide">
                    <strong>첨부파일 :</strong>
                    <a
                      href="javascript:void(0)"
                      class="btn-download"
                      @click="btnCmd()"
                      v-html="sanitizeHTML(props.data.orgnlFileNm)"
                    >
                    </a>
                  </div>
                </div>
                <div class="content">
                  <div v-html="sanitizeHTML(props.data.updtCn)" />
                </div>
              </div>
            </div>
          </div>

          <div class="dialog-footer">
            <div class="c-btn-area">
              <button
                type="button"
                class="c-button type-primary"
                @click="btnCmd()"
              >
                <span>업데이트 다운로드</span>
              </button>
            </div>
          </div>
        </div>
        <!-- D: dimmed -->
        <div class="dimmed"></div>
      </div>
    </template>
  </AbstractPop>
</template>
<script setup name="updateDetailDescPop">
import AbstractPop from "@/components/paintpro/common/AbstractPop.vue";
import { defineProps, defineEmits } from "vue";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";

const emits = defineEmits(["close"]);
const props = defineProps({
  data: {},
});

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd() {
  cmApi.fileDownload(props.data);
}

// script 태그와 이벤트 핸들러 제거
function sanitizeHTML(html) {
  return cmUtil.sanitizeHTML(html);
}
</script>
